<div class="flex flex-col justify-between min-h-screen p-4 container">
    <div class="flex flex-col items-center justify-center">
        <!-- intro -->
        <div class="flex flex-row my-16">
            <img src="/assets/car.svg" class="h-20"/>
            <div class="h-20 w-px bg-black block mx-6"></div>
            <div class="font-medium text-xl leading-tight">Willkommen,<br /><span class="font-normal text-base">melden Sie sich an<br />um fortzufahren.</span></div>
        </div>
        <!-- header -->
        <h1 class="text-black text-2xl w-full font-medium">Anmelden</h1>
        <h2 class="text-black w-full mb-4">Entdecken Sie die Schenk Service App</h2>
        <!-- login -->
        <div class="flex flex-col w-full">
            <!-- mail -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">E-Mail Adresse <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    [ngClass]="{'border-green-500': validMail === true, 'border-red-500': validMail === false}"
                    type="text"
                    [(ngModel)]="mail"
                    placeholder="mail@beispiel.de"
                    (blur)="validateMail()"
                />
            </div>
            <!-- pass -->
            <div class="flex flex-col relative">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Passwort <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400 pr-8"
                    [ngClass]="{'border-green-500': validPass === true, 'border-red-500': validPass === false}"
                    [type]="passType"
                    [(ngModel)]="pass"
                    placeholder="gHWf/3)K"
                    (blur)="validatePass()"
                />
                <button
                    class="absolute toggle-visabilty focus:outline-none focus:text-gray-700"
                    (click)="toggleVisability()"
                    title="Passwort anzeigen/verbergen"
                >
                    <fa-icon *ngIf="passType == 'password'" [icon]="eye"></fa-icon>
                    <fa-icon *ngIf="passType == 'text'" [icon]="eyeSlash"></fa-icon>
                </button>
            </div>
            <div class="flex flex-row justify-between my-4">
                <span class="text-gray-700"><sup>*</sup> Pflichtfelder</span>
                <a class="text-primary-500 hover:text-primary-700 focus:underline focus:outline-none" [routerLink]="['/reset']">
                    Passwort vergessen?
                </a>
            </div>
            <!-- error -->
            <div class="flex flex-row items-center justify-center mb-4 w-full bg-red-600 text-white px-4 py-2" *ngIf="error">
                <fa-icon [icon]="exclamationCircle"></fa-icon>
                <div class="h-4 w-px bg-white block mx-4"></div>
                <div>{{error}}</div>
            </div>
            <button class="btn btn-primary w-full" type="submit" (click)="login($event)">Anmelden <fa-icon [icon]="longArrowRight"></fa-icon></button>
        </div>
        <!-- register link-->
        <span class="text-sm text-center mt-4">
            Sie haben noch keinen Account?
            <a class="text-primary-500 hover:text-primary-700 focus:underline focus:outline-none" [routerLink]="['/register']">
                Registrieren
            </a>
        </span>
        <div *ngIf="iOS" class="bg-gray-200 w-full text-sm text-center flex flex-col justify-center items-center p-4 my-4">
            <h2 class="font-medium">Installieren Sie die Schenk Service App</h2>
            <p class="mt-3">1. Drücken Sie auf den Teilen Button</p>
            <img class="w-auto h-8 mt-2" src="/assets/pwa-share.svg" />
            <p class="mt-3">2. Wähle den Punkt "Zum Home-Bildschirm"</p>
            <div class="rounded-lg bg-white py-2 px-4 inline-flex w-full justify-between items-center mt-2">
                <span class="block">Zum Home-Bildschirm</span>
                <img class="w-auto h-4" src="/assets/pwa-add.svg" />
            </div>
            <p class="mt-3">3. Drücken Sie "Hinzufügen"</p>
            <div class="text-blue-500 bg-white py-2 px-4 mt-2 font-bold rounded-tr-lg">
                Hinzufügen
            </div>
        </div>
    </div>
    <app-legal></app-legal>
</div>